export enum FileIoTaskStepState {
  Created,
  InProgress,
  FinishedSuccess,
  FinishedFailure
}
